import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { WdxInfoCardButtonDirective } from './wdx-info-card-button/wdx-info-card-button.directive';
import { WdxInfoCardComponent } from './wdx-info-card/wdx-info-card.component';

@NgModule({
    declarations: [WdxInfoCardComponent, WdxInfoCardButtonDirective],
    imports: [CommonModule],
    exports: [WdxInfoCardComponent, WdxInfoCardButtonDirective],
})
export class WdxInfoCardModule {}
